import { Button } from '@mui/material';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import redux from '../../redux';

type EventDetailPayload = {
  id: string;
  name: string;
};
function BulkPauseUnpauseButton() {
  const { t } = useTranslation('bulkPauseUnpause');
  const dispatch: typeof redux.store.dispatch = useDispatch();

  const handleModalOpen = () => {
    dispatch(redux.modal.open());
  };
  const handleChange = (event: Event) => {
    const detail = (event as CustomEvent).detail;
    if (detail.length > 0) {
      setIsDisabled(false);
      dispatch(
        redux.bulkPauseUnpause.setIds(
          detail.map((obj: EventDetailPayload) => obj.id),
        ),
      );
      dispatch(
        redux.bulkPauseUnpause.setNames(
          detail.map((obj: EventDetailPayload) => obj.name),
        ),
      );
    } else {
      setIsDisabled(true);
    }
  };
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    window.addEventListener('MachineSelectionStatusChanged', handleChange);
    return () => {
      window.removeEventListener('MachineSelectionStatusChanged', handleChange);
    };
  }, []);

  return (
    <Button
      data-test-id="show-bulk-pause-unpause-modal"
      disabled={isDisabled}
      id="show-bulk-pause-unpause-modal"
      onClick={handleModalOpen}
      sx={{
        '&:disabled': {
          backgroundColor: '#1C5BFE',
          color: '#FFF',
          cursor: 'not-allowed',
          opacity: 0.5,
        },
        '&:hover': {
          backgroundColor: '#003AE7',
          color: '#FFF',
        },
        backgroundColor: '#1C5BFE',
        border: '0 none',
        borderRadius: '8px',
        color: '#FFF',
        fontFamily: 'Avenir Next',
        fontSize: '14px',
        fontWeight: 600,
        gap: '10px',
        height: '35px',
        letterSpacing: '0px',
        lineHeight: '19px',
        padding: '20px 16px',
        textTransform: 'none',
      }}
    >
      {t('action.button-text')}
    </Button>
  );
}

export default BulkPauseUnpauseButton;
